/** Production site origin (no trailing slash). */
export const SITE_ORIGIN = "https://served.gg";

export const SITE_NAME = "Served";

export const TITLE_SUFFIX = " | Served";

/**
 * Default Open Graph / Twitter image path. Prefer /og-image.png at 1200×630 when available.
 */
export const DEFAULT_OG_IMAGE_PATH = "/og-image.png";

export const HOME_PAGE_TITLE = `${SITE_NAME} | Private DMCA Enforcement & Verified Creator Network`;

export const HOME_PAGE_DESCRIPTION =
  "Invite-only DMCA protection network for elite creators. Private DMCA enforcement, leak detection, and a verified creator network.";

export const FAQ_PAGE_TITLE = `Frequently Asked Questions${TITLE_SUFFIX}`;

export const FAQ_PAGE_DESCRIPTION =
  "Answers about SERVED creator protection, DMCA enforcement, eligibility, and how the network works.";

export const CONTACT_PAGE_TITLE = `Contact${TITLE_SUFFIX}`;

export const CONTACT_PAGE_DESCRIPTION =
  "Get in touch with SERVED about creator protection, DMCA services, and network eligibility.";

export const PRIVACY_PAGE_TITLE = `Privacy Policy${TITLE_SUFFIX}`;

export const PRIVACY_PAGE_DESCRIPTION =
  "How Served Ltd. handles information when you use SERVED and this website.";

export const TERMS_PAGE_TITLE = `Terms & Conditions${TITLE_SUFFIX}`;

export const TERMS_PAGE_DESCRIPTION =
  "Rules that apply when you use the SERVED website and services.";

export const THANK_YOU_PAGE_TITLE = `Thank You${TITLE_SUFFIX}`;

export const THANK_YOU_PAGE_DESCRIPTION =
  "Your submission was received. The SERVED team reviews applications regularly.";

/**
 * @param {string} text
 * @param {number} max
 * @returns {string}
 */
export function truncateMetaDescription(text, max = 160) {
  if (!text) return "";
  const t = text.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1).trimEnd()}\u2026`;
}

/**
 * @param {string} path
 * @returns {string}
 */
export function absoluteUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN}${p}`;
}
